
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ApolloError } from '@apollo/client/core';
import { AngularTokenService } from '@raysuelzer/angular-token';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { GetUserByInviteTokenGQL } from 'generated/graphql';

/**
 * This Resolver will check the Invite token
 * and return the user data if the token is valid
 * if it is invalid, it will redirect the user to
 * a page showing that the token is invalid.
 *
 */
@Injectable({
  providedIn: 'root'
})
export class AcceptInvitationResolver  {
  constructor(
    private _getUserByInviteTokenGQL: GetUserByInviteTokenGQL,
    private _router: Router,
    private _tokenService: AngularTokenService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<{
    user: { id: string; email: string; firstName: string; lastName: string; phoneNumber?: string };
    token: string;
  }> {
    const token = route.queryParamMap.get('invitation_token');

    return this._tokenService.signOut().pipe(
      catchError((err) => observableOf(null)), // Ignore sign out error
      mergeMap(r => this._getUserByInviteTokenGQL.fetch({
        invitationToken: token
      })
      ),
      map(({ data }) => data.getUserByInvitationToken),
      catchError((err: ApolloError) => {
        console.error(err);
        this._router.navigateByUrl('invitation_invalid');
        // just return something
        return observableOf(null);
      }),
      map((data) => {
        if (data === null) {
          return null;
        }
        return {
          user: data,
          token
        };
      })
    );
  }
}
